
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("c5HAh"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("c5HAh", function(module, exports) {

let $8cd7c28ec0aadeb4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8cd7c28ec0aadeb4$var$load("5wVuh"),
    $8cd7c28ec0aadeb4$var$load("4NznW"),
    $8cd7c28ec0aadeb4$var$load("jf18J"),
    $8cd7c28ec0aadeb4$var$load("1F2Py"),
    $8cd7c28ec0aadeb4$var$load("lJ0p6"),
    $8cd7c28ec0aadeb4$var$load("cjaF7"),
    $8cd7c28ec0aadeb4$var$load("gknbb"),
    $8cd7c28ec0aadeb4$var$load("6iz6l"),
    $8cd7c28ec0aadeb4$var$load("4SCW2"),
    $8cd7c28ec0aadeb4$var$load("36QeB"),
    $8cd7c28ec0aadeb4$var$load("9q75n"),
    $8cd7c28ec0aadeb4$var$load("iYHbd"),
    $8cd7c28ec0aadeb4$var$load("7aMek"),
    $8cd7c28ec0aadeb4$var$load("3q2Ng"),
    $8cd7c28ec0aadeb4$var$load("jRpDi"),
    $8cd7c28ec0aadeb4$var$load("hnGEQ"),
    $8cd7c28ec0aadeb4$var$load("3GuOt"),
    $8cd7c28ec0aadeb4$var$load("jbM5v"),
    $8cd7c28ec0aadeb4$var$load("dek7I"),
    $8cd7c28ec0aadeb4$var$load("dYtBN"),
    $8cd7c28ec0aadeb4$var$load("kNV5Y"),
    $8cd7c28ec0aadeb4$var$load("6SWFK"),
    $8cd7c28ec0aadeb4$var$load("9aQIt"),
    $8cd7c28ec0aadeb4$var$load("5zapo"),
    $8cd7c28ec0aadeb4$var$load("3MYQs"),
    $8cd7c28ec0aadeb4$var$load("XZauT"),
    $8cd7c28ec0aadeb4$var$load("4S1SF"),
    $8cd7c28ec0aadeb4$var$load("jiFtb"),
    $8cd7c28ec0aadeb4$var$load("lm9Lt"),
    $8cd7c28ec0aadeb4$var$load("9atVd"),
    $8cd7c28ec0aadeb4$var$load("9wPDc"),
    $8cd7c28ec0aadeb4$var$load("1MWOL"),
    $8cd7c28ec0aadeb4$var$load("6fQco"),
    $8cd7c28ec0aadeb4$var$load("aOY32"),
    $8cd7c28ec0aadeb4$var$load("7jSfd"),
    $8cd7c28ec0aadeb4$var$load("4HZlX"),
    $8cd7c28ec0aadeb4$var$load("kDqHr"),
    $8cd7c28ec0aadeb4$var$load("6wr18"),
    $8cd7c28ec0aadeb4$var$load("gT8XU"),
    $8cd7c28ec0aadeb4$var$load("53AGa"),
    $8cd7c28ec0aadeb4$var$load("8bhm4"),
    $8cd7c28ec0aadeb4$var$load("ffEVr"),
    $8cd7c28ec0aadeb4$var$load("7EorR"),
    $8cd7c28ec0aadeb4$var$load("8k9aB"),
    $8cd7c28ec0aadeb4$var$load("fLwVm"),
    $8cd7c28ec0aadeb4$var$load("kuFG2"),
    $8cd7c28ec0aadeb4$var$load("hhss7"),
    $8cd7c28ec0aadeb4$var$load("Wowvf"),
    $8cd7c28ec0aadeb4$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("6Mg59"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("6Mg59", function(module, exports) {

let $4ef3b357c542a241$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4ef3b357c542a241$var$load("6wr18"),
    $4ef3b357c542a241$var$load("7aMek"),
    $4ef3b357c542a241$var$load("53AGa"),
    $4ef3b357c542a241$var$load("8bhm4"),
    $4ef3b357c542a241$var$load("ffEVr"),
    $4ef3b357c542a241$var$load("2tIxk"),
    $4ef3b357c542a241$var$load("dLq4a"),
    $4ef3b357c542a241$var$load("hhss7"),
    $4ef3b357c542a241$var$load("aQh37"),
    $4ef3b357c542a241$var$load("bJVDE"),
    $4ef3b357c542a241$var$load("8k9aB"),
    $4ef3b357c542a241$var$load("fLwVm"),
    $4ef3b357c542a241$var$load("kuFG2"),
    $4ef3b357c542a241$var$load("cjaF7"),
    $4ef3b357c542a241$var$load("h3ABO"),
    $4ef3b357c542a241$var$load("kC80R"),
    $4ef3b357c542a241$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("g4ZsM"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("g4ZsM", function(module, exports) {

let $bb4cb25b58de1bfe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bb4cb25b58de1bfe$var$load("j4FoV"),
    $bb4cb25b58de1bfe$var$load("jf18J"),
    $bb4cb25b58de1bfe$var$load("lRfiO"),
    $bb4cb25b58de1bfe$var$load("fuks3"),
    $bb4cb25b58de1bfe$var$load("b9CA3"),
    $bb4cb25b58de1bfe$var$load("2YffH"),
    $bb4cb25b58de1bfe$var$load("lUDr0"),
    $bb4cb25b58de1bfe$var$load("8dwgS"),
    $bb4cb25b58de1bfe$var$load("9XOeB"),
    $bb4cb25b58de1bfe$var$load("xu7ej"),
    $bb4cb25b58de1bfe$var$load("iQ4FP"),
    $bb4cb25b58de1bfe$var$load("71gca"),
    $bb4cb25b58de1bfe$var$load("bFPFr"),
    $bb4cb25b58de1bfe$var$load("82Jpo"),
    $bb4cb25b58de1bfe$var$load("d2YjW"),
    $bb4cb25b58de1bfe$var$load("im1VN"),
    $bb4cb25b58de1bfe$var$load("6WAC7"),
    $bb4cb25b58de1bfe$var$load("czOM6"),
    $bb4cb25b58de1bfe$var$load("jWHz7"),
    $bb4cb25b58de1bfe$var$load("7o9KM"),
    $bb4cb25b58de1bfe$var$load("j8WjL"),
    $bb4cb25b58de1bfe$var$load("8auEH"),
    $bb4cb25b58de1bfe$var$load("4S9KJ"),
    $bb4cb25b58de1bfe$var$load("hKRLP"),
    $bb4cb25b58de1bfe$var$load("9anPW"),
    $bb4cb25b58de1bfe$var$load("3EXzu"),
    $bb4cb25b58de1bfe$var$load("b2FtX"),
    $bb4cb25b58de1bfe$var$load("gnDXu"),
    $bb4cb25b58de1bfe$var$load("dl2qY"),
    $bb4cb25b58de1bfe$var$load("kL5FA"),
    $bb4cb25b58de1bfe$var$load("6iz6l"),
    $bb4cb25b58de1bfe$var$load("4SCW2"),
    $bb4cb25b58de1bfe$var$load("9q75n"),
    $bb4cb25b58de1bfe$var$load("iYHbd"),
    $bb4cb25b58de1bfe$var$load("3q2Ng"),
    $bb4cb25b58de1bfe$var$load("jRpDi"),
    $bb4cb25b58de1bfe$var$load("5wVuh"),
    $bb4cb25b58de1bfe$var$load("4NznW"),
    $bb4cb25b58de1bfe$var$load("7hmKj"),
    $bb4cb25b58de1bfe$var$load("14Bh4"),
    $bb4cb25b58de1bfe$var$load("c0JsV"),
    $bb4cb25b58de1bfe$var$load("h3ABO"),
    $bb4cb25b58de1bfe$var$load("gYQRR"),
    $bb4cb25b58de1bfe$var$load("4XdkL"),
    $bb4cb25b58de1bfe$var$load("4eock"),
    $bb4cb25b58de1bfe$var$load("8k9aB"),
    $bb4cb25b58de1bfe$var$load("fLwVm"),
    $bb4cb25b58de1bfe$var$load("6wr18"),
    $bb4cb25b58de1bfe$var$load("35cvG"),
    $bb4cb25b58de1bfe$var$load("Wowvf"),
    $bb4cb25b58de1bfe$var$load("2tIxk"),
    $bb4cb25b58de1bfe$var$load("dLq4a"),
    $bb4cb25b58de1bfe$var$load("ffEVr"),
    $bb4cb25b58de1bfe$var$load("hhss7"),
    $bb4cb25b58de1bfe$var$load("aQh37"),
    $bb4cb25b58de1bfe$var$load("bJVDE"),
    $bb4cb25b58de1bfe$var$load("cjaF7"),
    $bb4cb25b58de1bfe$var$load("jnVKv"),
    $bb4cb25b58de1bfe$var$load("7EorR"),
    $bb4cb25b58de1bfe$var$load("bgHzk"),
    $bb4cb25b58de1bfe$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.1d5403d4.js.map
